<template lang="pug">
  #menu.right(:class="{'open': open }")
    a(@click="toggle").btn
      div(v-if="!open").closed
        span menu
        More
      div(v-else).opened
        span fechar
        Close
    nav#navMain
      router-link(to="/sobre").link Sobre
      router-link(to="/portfolio").link Portfólio
      router-link(to="/contato").link Contato
      //- NavSocial
      NavSocial(v-if="open && navSocial", :nav="navSocial")
</template>

<script>
import './style.sass'
import More from '@/assets/svg/md-more.svg'
import Close from '@/assets/svg/ios-close.svg'
import NavSocial from '@/components/NavSocial/index.vue'

export default {
  name: 'Nav',
  props: {
    navSocial: Array
  },
  components: {
    More,
    Close,
    NavSocial
  },
  data: () => ({
    open: false
  }),
  methods: {
    toggle: function() {
      this.open = !this.open
    }
  },
  watch:{
    $route () {
      this.open = false
    }
  },
}
</script>